// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2mMmd","alert":"SettungsInbox_alert__1D00J"};